import { FloatingFormItem, InputDecimal } from '@/components/_common';
import { useDefaultEmptyFieldError } from '@/hooks';
import { Card, Col, Form, FormInstance, Input, Row, Select } from 'antd';
import { issExigibilityOptions, issTaxTypeOptions } from './options';
import { useInvoiceFormContext } from '../../../InvoiceFormProvider';

interface Props {
  form: FormInstance;
}

const InvoiceServiceIssForm: React.FC<Props> = ({ form }) => {
  const { disabledFields } = useInvoiceFormContext();

  const required = useDefaultEmptyFieldError();

  const issWithheld = Form.useWatch(['itemTaxes', 'iss', 'withheld'], form);

  return (
    <Form form={form} preserve={false} disabled={disabledFields}>
      <Card type="inner" title="Informações de ISS">
        <Row gutter={[16, 16]} style={{ width: '100%' }}>
          <Col span={24} sm={12} lg={8}>
            <FloatingFormItem
              label="Tipo de tributação"
              name={['itemTaxes', 'iss', 'taxType']}
            >
              <Select options={issTaxTypeOptions} allowClear />
            </FloatingFormItem>
          </Col>

          <Col span={24} sm={12} lg={8}>
            <FloatingFormItem
              label="Exigibilidade"
              name={['itemTaxes', 'iss', 'exigibility']}
            >
              <Select options={issExigibilityOptions} allowClear />
            </FloatingFormItem>
          </Col>

          <Col span={24} sm={12} lg={8}>
            <FloatingFormItem
              label="Retido"
              name={['itemTaxes', 'iss', 'withheld']}
            >
              <Select
                options={[
                  {
                    value: 'true',
                    label: 'Sim',
                  },
                  {
                    value: 'false',
                    label: 'Não',
                  },
                ]}
              />
            </FloatingFormItem>
          </Col>

          <Col span={24} sm={12} lg={8}>
            <FloatingFormItem
              label="Aliquota"
              name={['itemTaxes', 'iss', 'rate']}
              rules={[required]}
            >
              <InputDecimal fractions={4} max={100} />
            </FloatingFormItem>
          </Col>

          <Col span={24} sm={12} lg={8}>
            <FloatingFormItem
              label="Valor"
              name={['itemTaxes', 'iss', 'value']}
            >
              <InputDecimal />
            </FloatingFormItem>
          </Col>

          {issWithheld === 'true' && (
            <Col span={24} sm={12} lg={8}>
              <FloatingFormItem
                label="Valor retido"
                name={['itemTaxes', 'iss', 'withheldValue']}
              >
                <InputDecimal />
              </FloatingFormItem>
            </Col>
          )}

          <Col span={24} sm={12} lg={8}>
            <FloatingFormItem
              label="Processo suspensão"
              name={['itemTaxes', 'iss', 'suspensionProcess']}
            >
              <Input />
            </FloatingFormItem>
          </Col>
        </Row>
      </Card>
    </Form>
  );
};

export default InvoiceServiceIssForm;
